
import {
  defineComponent,
  computed,
  PropType,
} from 'vue';

import Button from 'primevue/button';
import Tooltip from 'primevue/tooltip';

interface FunnelStepData {
  idSend: number;
  date: string;
  channel: number;
  templateName: string;
}

export default defineComponent({
  name: 'DataViewerFunnelStep',

  components: {
    Button,
  },

  directives: {
    tooltip: Tooltip,
  },

  props: {
    funnelStep: {
      type: Object as PropType<FunnelStepData>,
      required: true,
    },

    funnelData: {
      type: Array as PropType<FunnelStepData[]>,
      required: true,
    },

    currentIdSend: {
      type: Number,
      required: true,
    },
  },

  emits: ['select-funnel'],

  setup(props, { emit }) {
    const funnelStepName = computed(() => props.funnelStep.templateName);

    const currentIndex = computed(() => props.funnelData.findIndex(
      (step) => step.idSend === props.funnelStep.idSend,
    ));

    const nextStep = computed(() => {
      const index = currentIndex.value;
      if (index === -1 || index >= props.funnelData.length - 1) {
        return null;
      }
      return props.funnelData[index + 1];
    });

    const hasNextStep = computed(() => nextStep.value !== null);

    const handleSelectFunnel = (idSend: number | undefined) => {
      if (idSend !== undefined && idSend !== props.currentIdSend) {
        emit('select-funnel', idSend);
      }
    };

    const handleChildSelectFunnel = (idSend: number) => {
      emit('select-funnel', idSend);
    };

    const isActive = computed(() => props.funnelStep.idSend === props.currentIdSend);

    return {
      nextStep,
      isActive,
      funnelStepName,
      hasNextStep,
      handleSelectFunnel,
      handleChildSelectFunnel,
    };
  },
});
